// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/identity_verification/verification/firstparty/v4/identity_verification.proto

/* oxlint-disable */

/** The provider handling the identity verification. */
export const ApiProvider = {
  /** PROVIDER_UNSPECIFIED - Unspecified provider. */
  PROVIDER_UNSPECIFIED: "PROVIDER_UNSPECIFIED",
  /**
   * fourthline - Fourthline.
   */
  fourthline: "fourthline",
  /**
   * idnow - IDNow VideoIdent.
   */
  idnow: "idnow",
  /**
   * onfido - Onfido.
   */
  onfido: "onfido",
} as const;

export type ApiProvider = typeof ApiProvider[keyof typeof ApiProvider];

export namespace ApiProvider {
  export type PROVIDER_UNSPECIFIED = typeof ApiProvider.PROVIDER_UNSPECIFIED;
  export type fourthline = typeof ApiProvider.fourthline;
  export type idnow = typeof ApiProvider.idnow;
  export type onfido = typeof ApiProvider.onfido;
}

export function apiProviderFromJSON(object: any): ApiProvider {
  switch (object) {
    case 0:
    case "PROVIDER_UNSPECIFIED":
      return ApiProvider.PROVIDER_UNSPECIFIED;
    case 1:
    case "fourthline":
      return ApiProvider.fourthline;
    case 2:
    case "idnow":
      return ApiProvider.idnow;
    case 3:
    case "onfido":
      return ApiProvider.onfido;
    default:
      return ApiProvider.PROVIDER_UNSPECIFIED;
  }
}

export function apiProviderToJSON(object: ApiProvider): string {
  switch (object) {
    case ApiProvider.PROVIDER_UNSPECIFIED:
      return "PROVIDER_UNSPECIFIED";
    case ApiProvider.fourthline:
      return "fourthline";
    case ApiProvider.idnow:
      return "idnow";
    case ApiProvider.onfido:
      return "onfido";
    default:
      return "PROVIDER_UNSPECIFIED";
  }
}

/** The status of the identity verification. */
export const ApiStatus = {
  /** STATUS_UNSPECIFIED - Unspecified status. */
  STATUS_UNSPECIFIED: "STATUS_UNSPECIFIED",
  /**
   * pending - The verification has not started.
   */
  pending: "pending",
  /**
   * in_progress - The verification is in progress.
   */
  in_progress: "in_progress",
  /**
   * awaiting_result - The verification is awaiting a result from the provider.
   */
  awaiting_result: "awaiting_result",
  /**
   * completed - The verification has completed.
   */
  completed: "completed",
} as const;

export type ApiStatus = typeof ApiStatus[keyof typeof ApiStatus];

export namespace ApiStatus {
  export type STATUS_UNSPECIFIED = typeof ApiStatus.STATUS_UNSPECIFIED;
  export type pending = typeof ApiStatus.pending;
  export type in_progress = typeof ApiStatus.in_progress;
  export type awaiting_result = typeof ApiStatus.awaiting_result;
  export type completed = typeof ApiStatus.completed;
}

export function apiStatusFromJSON(object: any): ApiStatus {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return ApiStatus.STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiStatus.pending;
    case 2:
    case "in_progress":
      return ApiStatus.in_progress;
    case 3:
    case "awaiting_result":
      return ApiStatus.awaiting_result;
    case 4:
    case "completed":
      return ApiStatus.completed;
    default:
      return ApiStatus.STATUS_UNSPECIFIED;
  }
}

export function apiStatusToJSON(object: ApiStatus): string {
  switch (object) {
    case ApiStatus.STATUS_UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case ApiStatus.pending:
      return "pending";
    case ApiStatus.in_progress:
      return "in_progress";
    case ApiStatus.awaiting_result:
      return "awaiting_result";
    case ApiStatus.completed:
      return "completed";
    default:
      return "STATUS_UNSPECIFIED";
  }
}

/** The type of an evidence item. */
export const ApiEvidenceType = {
  /** EVIDENCE_TYPE_UNSPECIFIED - Unspecified evidence type. */
  EVIDENCE_TYPE_UNSPECIFIED: "EVIDENCE_TYPE_UNSPECIFIED",
  /**
   * proof_of_identity - Proof of identity document.
   */
  proof_of_identity: "proof_of_identity",
  /**
   * liveness - Liveness check.
   */
  liveness: "liveness",
  /**
   * qualified_electronic_signature - Qualified electronic signature.
   */
  qualified_electronic_signature: "qualified_electronic_signature",
} as const;

export type ApiEvidenceType = typeof ApiEvidenceType[keyof typeof ApiEvidenceType];

export namespace ApiEvidenceType {
  export type EVIDENCE_TYPE_UNSPECIFIED = typeof ApiEvidenceType.EVIDENCE_TYPE_UNSPECIFIED;
  export type proof_of_identity = typeof ApiEvidenceType.proof_of_identity;
  export type liveness = typeof ApiEvidenceType.liveness;
  export type qualified_electronic_signature = typeof ApiEvidenceType.qualified_electronic_signature;
}

export function apiEvidenceTypeFromJSON(object: any): ApiEvidenceType {
  switch (object) {
    case 0:
    case "EVIDENCE_TYPE_UNSPECIFIED":
      return ApiEvidenceType.EVIDENCE_TYPE_UNSPECIFIED;
    case 1:
    case "proof_of_identity":
      return ApiEvidenceType.proof_of_identity;
    case 2:
    case "liveness":
      return ApiEvidenceType.liveness;
    case 3:
    case "qualified_electronic_signature":
      return ApiEvidenceType.qualified_electronic_signature;
    default:
      return ApiEvidenceType.EVIDENCE_TYPE_UNSPECIFIED;
  }
}

export function apiEvidenceTypeToJSON(object: ApiEvidenceType): string {
  switch (object) {
    case ApiEvidenceType.EVIDENCE_TYPE_UNSPECIFIED:
      return "EVIDENCE_TYPE_UNSPECIFIED";
    case ApiEvidenceType.proof_of_identity:
      return "proof_of_identity";
    case ApiEvidenceType.liveness:
      return "liveness";
    case ApiEvidenceType.qualified_electronic_signature:
      return "qualified_electronic_signature";
    default:
      return "EVIDENCE_TYPE_UNSPECIFIED";
  }
}

/** The collection status of an evidence item. */
export const ApiEvidenceStatus = {
  /** EVIDENCE_STATUS_UNSPECIFIED - Unspecified evidence status. */
  EVIDENCE_STATUS_UNSPECIFIED: "EVIDENCE_STATUS_UNSPECIFIED",
  /**
   * required - The evidence is required but not yet collected.
   */
  required: "required",
  /**
   * collected - The evidence has been collected.
   */
  collected: "collected",
  /**
   * bypassed - The evidence was bypassed.
   */
  bypassed: "bypassed",
} as const;

export type ApiEvidenceStatus = typeof ApiEvidenceStatus[keyof typeof ApiEvidenceStatus];

export namespace ApiEvidenceStatus {
  export type EVIDENCE_STATUS_UNSPECIFIED = typeof ApiEvidenceStatus.EVIDENCE_STATUS_UNSPECIFIED;
  export type required = typeof ApiEvidenceStatus.required;
  export type collected = typeof ApiEvidenceStatus.collected;
  export type bypassed = typeof ApiEvidenceStatus.bypassed;
}

export function apiEvidenceStatusFromJSON(object: any): ApiEvidenceStatus {
  switch (object) {
    case 0:
    case "EVIDENCE_STATUS_UNSPECIFIED":
      return ApiEvidenceStatus.EVIDENCE_STATUS_UNSPECIFIED;
    case 1:
    case "required":
      return ApiEvidenceStatus.required;
    case 2:
    case "collected":
      return ApiEvidenceStatus.collected;
    case 3:
    case "bypassed":
      return ApiEvidenceStatus.bypassed;
    default:
      return ApiEvidenceStatus.EVIDENCE_STATUS_UNSPECIFIED;
  }
}

export function apiEvidenceStatusToJSON(object: ApiEvidenceStatus): string {
  switch (object) {
    case ApiEvidenceStatus.EVIDENCE_STATUS_UNSPECIFIED:
      return "EVIDENCE_STATUS_UNSPECIFIED";
    case ApiEvidenceStatus.required:
      return "required";
    case ApiEvidenceStatus.collected:
      return "collected";
    case ApiEvidenceStatus.bypassed:
      return "bypassed";
    default:
      return "EVIDENCE_STATUS_UNSPECIFIED";
  }
}

/** A single evidence item required or collected for the identity verification. */
export interface ApiEvidence {
  /** The type of evidence. */
  readonly evidenceType: ApiEvidenceType;
  /** The collection status of the evidence. */
  readonly status: ApiEvidenceStatus;
}

export const ApiEvidence: MessageFns<ApiEvidence> = {
  fromJSON(object: any): ApiEvidence {
    return {
      evidenceType: isSet(object.evidence_type)
        ? apiEvidenceTypeFromJSON(object.evidence_type)
        : ApiEvidenceType.EVIDENCE_TYPE_UNSPECIFIED,
      status: isSet(object.status)
        ? apiEvidenceStatusFromJSON(object.status)
        : ApiEvidenceStatus.EVIDENCE_STATUS_UNSPECIFIED,
    };
  },

  toJSON(message: ApiEvidence): unknown {
    const obj: any = {};
    if (message.evidenceType !== undefined && message.evidenceType !== null) {
      obj.evidence_type = apiEvidenceTypeToJSON(message.evidenceType);
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiEvidenceStatusToJSON(message.status);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
